// src/api/Prescription/useEditPrescription.ts

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { Methods } from "../../Constants/ApiConstants";
import {
  EditPrescriptionDrug,
  PrescriptionType
} from "../../interface/GeneralResponse";
import { updatePrescription } from "../../redux/reducers/prescriptionsSlice";
import Api from "../generalApi/Api";

export interface EditPrescriptionParams {
  id: number;
  data: {
    Case: string;
    Drugs: EditPrescriptionDrug[];
  };
}


const useEditPrescription = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation<PrescriptionType, Error, EditPrescriptionParams>({
    mutationFn: async ({ id, data }: EditPrescriptionParams) => {
      const response = await Api<typeof data, PrescriptionType>({
        method: Methods.POST,
        endpoint: `Prescription/Edit/${id}`,
        body: data,
      });
      return response;
    },
    onSuccess: (data: PrescriptionType, variables: EditPrescriptionParams) => {
      dispatch(updatePrescription(data));
      queryClient.invalidateQueries({ queryKey: ["prescription", data.Id] });
    }
  });
};

export default useEditPrescription;
